<div class="flex-container prescription-header" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
    <div fxFlex="20px;">
        <fa-icon *ngIf="entry.getProperty('type') == 'medication'" [icon]="['fas', 'pills']"></fa-icon>
        <fa-icon *ngIf="entry.getProperty('type') == 'treatment'" [icon]="['fas', 'file']"></fa-icon>
    </div>
    <div fxFlex="grow">
        <div class="prescription-label">{{ entry.getProperty('packagelabel') || entry.value }}</div>
        <app-prescription-posology [entry]="entry" class="prescription-posology"></app-prescription-posology>
    </div>
    <div fxFlex="40px" class="prescription-edit-button">
        <button mat-icon-button (click)="editEntry()"><fa-icon [icon]="['fas', 'pen']" class="action-fa-icon" size="lg"></fa-icon></button>
    </div>
    <div fxFlex="40px" class="prescription-edit-button">
        <button mat-icon-button (click)="removeEntry()"><fa-icon [icon]="['fas', 'trash']" class="action-fa-icon" size="lg"></fa-icon></button>
    </div>
</div>
